import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from '@schedule-x/angular';
import {
  createViewMonthGrid,
  createViewList,
  createCalendar,
  createViewDay,
} from '@schedule-x/calendar';
import { calendarConfig } from '../../providers/static-data';
import { createDragAndDropPlugin } from '@schedule-x/drag-and-drop';
import { createEventModalPlugin } from '@schedule-x/event-modal';
import { createEventRecurrencePlugin } from '@schedule-x/event-recurrence';
import { ScheduleDrawerControlComponent } from '../../components/schedule/schedule-drawer-control/schedule-drawer-control.component';
import { SchedulesHelperService } from './schedules-helper.service';
import { SchedulesApiService } from './schedules-api.service';
import { environment } from '../../../environments/environment';
import { LoaderComponent } from '../../providers/loader.component';
import { finalize, Observable } from 'rxjs';
import { FilterBaseAccessService } from '../../auth/filterbase-access';
// import '@schedule-x/theme-shadcn/dist/index.css';
import { CascadingSelectServiceService } from '../services/cascading-select-service.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { CourseApiServiceService } from '../courses/course-api-service.service';
// import '@schedule-x/theme-default/dist/index.css'

@Component({
  selector: 'app-schedules',
  standalone: true,
  imports: [
    CommonModule,
    CalendarComponent,
    ScheduleDrawerControlComponent,
    LoaderComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './schedules.component.html',
  styleUrl: './schedules.component.css',
})
export class SchedulesComponent {
  DragPlugin = createDragAndDropPlugin();
  EventModalPlugin = createEventModalPlugin();
  EventRecurrencePlugin = createEventRecurrencePlugin();

  allowedPlugings: any[] = [];
  callbacks: any;
  calendarApp: any;
  calendarEvents: any[] = [];  originalApiEvents: any[] = [] // Store original API events
  isAnalyticsView: boolean = false;
  isAnalyticsModalOpen: boolean = false;
  showAllStudentRemarks: boolean = false;
  selectedAnalyticsEvent: any = null;
  isMarkCompleteModalOpen: boolean = false;
  selectedMarkCompleteEvent: any = null;

  isReqSend: boolean = false;
  isCalendarLoading: boolean = false;

  stats = [
    { id: 1, title: 'scheduled', count: 50, icon: 'ri-calendar-schedule-line' },
    { id: 1, title: 'completed', count: 32, icon: 'ri-calendar-check-line' },
    { id: 1, title: 'uncompleted', count: 8, icon: 'ri-calendar-close-line' },
    { id: 1, title: 'upcoming', count: 10, icon: 'ri-calendar-event-line' },
  ];

  viewType: 'monthly' | 'weekly' = 'monthly';
  weeklyTabs: string[] = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun',
  ];
  activeWeeklyTab: string = 'Week';
  weeklyDate: Date = new Date();

  view_schedules: boolean = false;
  create_schedule_event: boolean = false;
  view_analytics: boolean = false;

  filterForm!: FormGroup;
  departments: any[] = [];
  classes: any[] = [];
  batches: any[] = [];
  academicYear$!: Observable<any>;
  monthLabel: string = '';
  monthDays: { label: string; date: number; active: boolean }[] = [];
  timeSlots: string[] = ['10:00 am', '11:00 am', '12:00 pm', '01:00 pm', '02:00 pm', '03:00 pm'];
  timelineColumns: number[] = [0, 1, 2, 3];
  monthlyTimelineCards: any[] = [];
  selectedDate: Date = new Date();
  dayStartHour: number = 10;
  dayEndHour: number = 16;

  constructor(
    private helperServce: SchedulesHelperService,
    private scheduleApiService: SchedulesApiService,
    private route: ActivatedRoute,
    private access: FilterBaseAccessService,
    private cascadedService: CascadingSelectServiceService,
    private fb: FormBuilder,
    private toasterService: ToasterService,
    private courseApiService: CourseApiServiceService,
  ) {}

  ngOnInit(): void {
    this.viewType =
      this.route.snapshot.data['menu_name'] === 'Monthly Scheduler'
        ? 'monthly'
        : 'weekly';
    this.initializePermissions();
    this.initializeCalendar();
    this.setupDrawerCloseSubscription();
    this.filterForm = this.fb.group({
      department: [null],
      class: [{ value: null, disabled: true }],
      batch: [{ value: null, disabled: true }],
      academic_year: [null],
      date_range: ["today"],
      customize_from: [null],
      customize_to: [null],
    });

    this.academicYear$ = this.cascadedService.academicYear$;
    this.cascadedService.academicEntries$.subscribe((res: any) => {
      this.departments = res?.data ?? [];
    });
  }

  initializePermissions() {
    if (this.viewType === 'monthly') {
      this.view_schedules =
        this.access.checkaccessforfiltersandactions('monthly scheduler');
      this.create_schedule_event = this.access.checkaccessforfiltersandactions(
        'monthly schedule event',
      );
      this.view_analytics =
        this.access.checkaccessforfiltersandactions('monthly analytics');
    } else {
      this.view_schedules =
        this.access.checkaccessforfiltersandactions('weekly planner');
      this.create_schedule_event = this.access.checkaccessforfiltersandactions(
        'weekly planner event',
      );
      this.view_analytics =
        this.access.checkaccessforfiltersandactions('weekly analytics');
    }
  }

  initializeCalendar() {
    this.allowedPlugings.push(this.DragPlugin);
    // this.allowedPlugings.push(this.EventModalPlugin)
    this.allowedPlugings.push(this.EventRecurrencePlugin);

    this.callbacks = {
      onEventClick: (event: any, e?: Event) => {
        console.log('onEventClick', event);
        e?.stopPropagation?.();
        this.viewEvent(event);
      },
      onEventDoubleClick: (event: any, e?: Event) => {
        console.log('onEventDoubleClick', event);
        e?.stopPropagation?.();
        this.viewEvent(event);
      },
      onEventUpdate: (updatedEvent: any) => {
        console.log('onEventUpdate', updatedEvent);
      },
      onClickDate: (date: any) => {
        this.openCreateForm(date);
      },
      onRangeUpdate: (start: any, end: any) => {
        console.log('onRangeUpdate', start, end);
      },
    };

    this.loadCalendarEvents();
  }

  setupDrawerCloseSubscription() {
    this.helperServce.drawerClosed$.subscribe(() => {
      // Refetch all events when drawer closes
      this.loadCalendarEvents();
    });
  }

  private loadCalendarEvents() {
    this.isCalendarLoading = true;
    this.scheduleApiService
      .getAllCalendarEvents()
      .pipe(
        finalize(() => {
          this.isCalendarLoading = false;
        }),
      )
      .subscribe({
        next: (res: any) => {
          const payload =
            res?.status === 'success' ? res?.data : (res?.data ?? res);
          const eventsArray = Array.isArray(payload) ? payload : [];
          
          // Store original API events
          this.originalApiEvents = eventsArray;
          
          this.calendarEvents = this.mapApiEvents(eventsArray);
          this.buildMonthlyTimeline(this.calendarEvents);

          this.buildCalendar(this.calendarEvents);
        },
      });
  }

  private buildCalendar(events: any[]) {
    this.calendarApp = createCalendar({
      events,
      calendars: calendarConfig,
      theme: 'shadcn',
      views: [
        // createViewMonthAgenda(),
        createViewMonthGrid(),
        // createViewWeek(),
        // createViewDay(),
        // createViewList(),
      ],
      defaultView: this.viewType === 'monthly' ? 'monthGrid' : 'week',
      plugins: this.allowedPlugings,
      callbacks: this.callbacks,
    });
  }

  private mapApiEvents(events: any[]): any[] {
    const validCalendarIds = Object.keys(calendarConfig); // ['lecture','seminar','workshop',...]

    return events
      .map((event: any, index: number) => {
        const start = this.normalizeDate(
          event?.start ??
            event?.start_time ??
            event?.startTime ??
            event?.start_date ??
            event?.from,
        );
        const end = this.normalizeDate(
          event?.end ??
            event?.end_time ??
            event?.endTime ??
            event?.end_date ??
            event?.to,
        );

        let rawId =
          event?.schedule_day_id ??
          event?.classroom_schedule_id ??
          event?.id ??
          event?._id ??
          event?.event_id;
        if (!rawId) {
          rawId = `${Date.now()}-${index}`;
        }
        const id = `evt-${String(rawId).replace(/[^a-zA-Z0-9_-]/g, '-')}`;

        // Resolve calendarId — check all possible type fields
        const rawCalendarId =
          event?.calendarId ??
          event?.calendar_id ??
          event?.event_type ?? // common backend field
          event?.schedule_type ?? // common backend field
          event?.type ??
          event?.category ??
          event?.source ?? // your API has "source": "schedule"
          'lecture';

        // Normalize to snake_case and validate against config
        const normalizedId = String(rawCalendarId)
          .toLowerCase()
          .replace(/\s+/g, '_');
        const calendarId = validCalendarIds.includes(normalizedId)
          ? normalizedId
          : 'lecture';

        return {
          id,
          title:
            event?.summary ??
            event?.title ??
            event?.name ??
            event?.event_title ??
            event?.session_title ??
            event?.description?.slice(0, 20) ?? "",
          start,
          end,
          calendarId,
          description: event?.description,
          people: event?.attendee ?? event?.people ?? event?.attendees,
          location: event?.location,
          rrule: event?.rrule ?? event?.recurrence,
        };
      })
      .filter((event: any) => {
        const valid = event.start && event.end && event.id;
        if (!valid) {
          console.warn('Skipped invalid event (missing start/end/id):', event);
        }
        return valid;
      });
  }

  private normalizeDate(value: any): string | null {
    if (!value) return null;

    if (typeof value === 'string') {
      // Already in Schedule-X format: "YYYY-MM-DD HH:mm"
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(value)) {
        return value.slice(0, 16);
      }

      // ISO string (with T and optional timezone like +05:30)
      const parsed = new Date(value);
      if (!isNaN(parsed.getTime())) {
        return this.formatScheduleXDate(parsed);
      }

      return null;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.formatScheduleXDate(value);
    }

    if (typeof value === 'object') {
      const nested =
        value?.dateTime ?? value?.date ?? value?.start ?? value?.end;
      if (nested) return this.normalizeDate(nested);
    }

    return null;
  }

  private formatScheduleXDate(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    // Use local time as-is — Date constructor already handles +05:30 offset
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const mins = pad(date.getMinutes());
    return `${year}-${month}-${day} ${hours}:${mins}`;
  }

  private buildMonthlyTimeline(events: any[]) {
    this.monthLabel = this.selectedDate.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    });

    const firstWeekStart = new Date(this.selectedDate);
    firstWeekStart.setDate(this.selectedDate.getDate() - 9);
    this.monthDays = Array.from({ length: 19 }, (_, idx) => {
      const d = new Date(firstWeekStart);
      d.setDate(firstWeekStart.getDate() + idx);
      return {
        label: d.toLocaleDateString('en-US', { weekday: 'short' }),
        date: d.getDate(),
        active: this.isSameDate(d, this.selectedDate),
      };
    });

    const selectedDateKey = this.toDateKey(this.selectedDate);
    const sameDayEvents = events.filter((event: any) => {
      if (!event?.start) return false;
      return this.toDateKey(new Date(event.start.replace(' ', 'T'))) === selectedDateKey;
    });

    const eventSource =
      sameDayEvents.length > 0
        ? sameDayEvents
        : events.length === 0
          ? this.getFallbackTimelineEvents()
          : [];

    this.rebuildTimeSlots(eventSource);

    // Sort events by start time to group same time events together
    eventSource.sort((a, b) => new Date(a.start.replace(' ', 'T')).getTime() - new Date(b.start.replace(' ', 'T')).getTime());

    // Calculate lanes to prevent overlapping
    const eventsWithLanes = this.calculateEventLanes(eventSource);

    this.monthlyTimelineCards = eventsWithLanes.map((eventData: any) => {
      const { event, column } = eventData;
      const startDate = new Date((event.start || '').replace(' ', 'T'));
      const endDate = new Date((event.end || '').replace(' ', 'T'));
      const rowStart = this.getRowIndexFromDate(startDate);
      const rowSpan = this.getRowSpanFromDates(startDate, endDate);
      const source = this.findOriginalEventById(event.id);

      // Determine card status and color
      const now = new Date();
      const eventStatus = source?.status;
      let colorClass = 'blue'; // default for upcoming events
      let showActionButtons = true;

      if (eventStatus === 'end') {
        colorClass = 'green';
        showActionButtons = false;
      } else if (endDate < now) {
        // Event has ended and status is not 'end'
        colorClass = 'red';
        showActionButtons = false;
      }

      return {
        id: event.id,
        title: event.title,
        start: event.start,
        end: event.end,
        timeRange: `${this.formatDisplayTime(startDate)} - ${this.formatDisplayTime(endDate)}`,
        teacher: this.getPrimaryTeacher(source?.attendee ?? event.people) || 'N/A',
        className: this.getPrimaryClass(source?.class_id),
        parameters: this.normalizeParameters(source?.additional_parameter),
        colorClass,
        showActionButtons,
        column,
        row: rowStart,
        rowSpan,
        originalEvent: source,
      };
    });
  }

  selectMonthlyDate(_day: { date: number; label: string; active: boolean }, index: number) {
    const start = new Date(this.selectedDate);
    start.setDate(this.selectedDate.getDate() - 9);
    const nextDate = new Date(start);
    nextDate.setDate(start.getDate() + index);
    this.selectedDate = nextDate;
    this.buildMonthlyTimeline(this.calendarEvents);
  }

  shiftMonthlyDate(step: number) {
    const d = new Date(this.selectedDate);
    d.setDate(d.getDate() + step);
    this.selectedDate = d;
    this.buildMonthlyTimeline(this.calendarEvents);
  }

  private isSameDate(a: Date, b: Date): boolean {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  private toDateKey(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  private getFallbackTimelineEvents() {
    return [
      
    ];
  }

  private formatDisplayTime(date: Date): string {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).toLowerCase();
  }

  private getRowIndexFromDate(date: Date): number {
    const minutesFromStart =
      date.getHours() * 60 + date.getMinutes() - this.dayStartHour * 60;
    return Math.max(0, Math.floor(minutesFromStart / 15));
  }

  private getRowSpanFromDates(startDate: Date, endDate: Date): number {
    const start = startDate.getHours() * 60 + startDate.getMinutes();
    const end = endDate.getHours() * 60 + endDate.getMinutes();
    const MIN_SLOT_MINUTES = 15; // Match the grid step so short events do not overlap later ones
    const MIN_CARD_MINUTES = 45; // Keep short cards readable with a minimum 45-minute height
    const diff = Math.max(MIN_SLOT_MINUTES, end - start);
    return Math.max(3, Math.ceil(Math.max(MIN_CARD_MINUTES, diff) / 15));
  }

  private rebuildTimeSlots(eventSource: any[]) {
    const defaultStart = 10;
    const defaultEnd = 16;

    if (!eventSource.length) {
      this.dayStartHour = defaultStart;
      this.dayEndHour = defaultEnd;
      this.timeSlots = this.buildHourLabels(this.dayStartHour, this.dayEndHour);
      return;
    }

    let minMinutes = Number.MAX_SAFE_INTEGER;
    let maxMinutes = 0;

    for (const event of eventSource) {
      const startDate = new Date((event.start || '').replace(' ', 'T'));
      const endDate = new Date((event.end || '').replace(' ', 'T'));
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) continue;
      const start = startDate.getHours() * 60 + startDate.getMinutes();
      const end = endDate.getHours() * 60 + endDate.getMinutes();
      minMinutes = Math.min(minMinutes, start);
      maxMinutes = Math.max(maxMinutes, end);
    }

    if (minMinutes === Number.MAX_SAFE_INTEGER) {
      this.dayStartHour = defaultStart;
      this.dayEndHour = defaultEnd;
    } else {
      this.dayStartHour = Math.min(defaultStart, Math.floor(minMinutes / 60));
      this.dayEndHour = Math.max(defaultEnd, Math.ceil(maxMinutes / 60));
      if (this.dayEndHour <= this.dayStartHour) {
        this.dayEndHour = this.dayStartHour + 1;
      }
    }

    this.timeSlots = this.buildHourLabels(this.dayStartHour, this.dayEndHour);
  }

  private buildHourLabels(startHour: number, endHour: number): string[] {
    return Array.from({ length: endHour - startHour }, (_, index) => {
      const hour = startHour + index;
      const period = hour >= 12 ? 'pm' : 'am';
      const h12 = hour % 12 === 0 ? 12 : hour % 12;
      return `${String(h12).padStart(2, '0')}:00 ${period}`;
    });
  }

  openCreateForm(date?: Date, time?: { start: string; end: string } | null) {
    if (!this.create_schedule_event) return;
    if (time && date) {
      const startDate = new Date(date);
      const endDate = new Date(date);
      const [sh, sm] = time.start.split(':').map((v) => Number(v));
      const [eh, em] = time.end.split(':').map((v) => Number(v));
      startDate.setHours(sh, sm, 0, 0);
      endDate.setHours(eh, em, 0, 0);
      this.helperServce.preselectedRange.set({ start: startDate, end: endDate });
    } else {
      this.helperServce.preselectedRange.set(null);
    }

    this.helperServce.openDrawer('form', 'create', null, null, date ?? null);
  }


  openEditForm(eventId: string) {
    this.helperServce.openDrawer('form', 'edit', eventId);
  }

  openMonthlyCardView(card: any) {
    const source = card?.originalEvent ?? this.findOriginalEventById(card?.id);
    const rawId = this.normalizeEventId(source ?? card?.id);
    if (!rawId) {
      this.helperServce.openDrawer('view', null, card?.id ?? null, source ?? null);
      return;
    }

    this.scheduleApiService.getEventById(rawId).subscribe({
      next: (res: any) => {
        const eventData = this.unwrapEventResponse(res);
        this.helperServce.openDrawer('view', null, rawId, eventData ?? source ?? null);
      },
      error: () => {
        this.helperServce.openDrawer('view', null, rawId, source ?? null);
      },
    });
  }

  openMonthlyCardEdit(card: any) {
    const source = card?.originalEvent ?? this.findOriginalEventById(card?.id);
    const rawId = this.normalizeEventId(source ?? card?.id);
    if (!rawId) {
      this.helperServce.openDrawer('form', 'edit', card?.id ?? null, source ?? null);
      return;
    }

    this.scheduleApiService.getEventById(rawId).subscribe({
      next: (res: any) => {
        const eventData = this.unwrapEventResponse(res);
        this.helperServce.openDrawer('form', 'edit', rawId, eventData ?? source ?? null);
      },
      error: () => {
        this.helperServce.openDrawer('form', 'edit', rawId, source ?? null);
      },
    });
  }
  
  openMonthlyCardDelete(card: any) {
    const source = card?.originalEvent ?? this.findOriginalEventById(card?.id);
    const rawId =
      source?.schedule_day_id ??
      source?.classroom_schedule_id ??
      source?.id ??
      source?._id ??
      card?.id;
    if (!rawId) return;

    const normalizedId = String(rawId).startsWith('evt-')
      ? String(rawId).replace(/^evt-/, '').split('-')[0]
      : rawId;

    this.scheduleApiService.deleteScheduleEvent(normalizedId).subscribe({
      next: () => this.loadCalendarEvents(),
      error: (err) => console.error('Failed to delete schedule event:', err),
    });
  }

  setWeeklyTab(tab: string) {
    this.activeWeeklyTab = tab;
  }

  shiftWeeklyMonth(step: number) {
    const d = new Date(this.weeklyDate);
    d.setMonth(d.getMonth() + step);
    this.weeklyDate = d;
  }

  openCreateForSlot(slotIndex: number) {
    if (!this.create_schedule_event) return;
    const selected = new Date(this.selectedDate);
    const startHour24 = this.dayStartHour + slotIndex;

    // Derive dropdown values used in schedule-form (HH:MM)
    const startTime = `${String(startHour24).padStart(2, '0')}:00`;
    const endHour24 = startHour24 + 1;
    const endTime = `${String(endHour24).padStart(2, '0')}:00`;

    this.openCreateForm(selected, { start: startTime, end: endTime });
  }




  viewEvent(calendarEvent: any) {
    // Find the original API event data that corresponds to this calendar event
    const originalEvent = this.findOriginalEventById(calendarEvent.id);
    if (this.viewType === 'monthly') {
      this.openAnalyticsModal(calendarEvent, originalEvent);
      return;
    }
    const rawId = this.normalizeEventId(originalEvent ?? calendarEvent?.id);
    if (!rawId) {
      this.helperServce.openDrawer('view', null, calendarEvent.id, originalEvent);
      return;
    }

    this.scheduleApiService.getEventById(rawId).subscribe({
      next: (res: any) => {
        const eventData = this.unwrapEventResponse(res);
        this.helperServce.openDrawer('view', null, rawId, eventData ?? originalEvent);
      },
      error: () => {
        this.helperServce.openDrawer('view', null, rawId, originalEvent);
      },
    });
  }

  private findOriginalEventById(eventId: string): any {
    // Extract the original ID from the calendar event ID (remove the 'evt-' prefix and timestamp)
    const originalId = eventId.replace('evt-', '').split('-')[0];
    
    // Find the original API event by schedule_day_id, classroom_schedule_id, or other ID fields
    return this.originalApiEvents.find(event => 
      event.schedule_day_id == originalId || 
      event.classroom_schedule_id == originalId ||
      event.id == originalId ||
      event._id == originalId
    );
  }

  setFields(event: Event, type: 'department' | 'class') {
    const target = event.target as HTMLSelectElement;
    const value = target?.value;

    if (!value || value === 'null') {
      if (type === 'department') {
        this.cascadedService.reset();
        this.filterForm.patchValue({ class: null, batch: null });
        this.filterForm.get('class')?.disable();
        this.filterForm.get('batch')?.disable();
        this.classes = [];
        this.batches = [];
      } else if (type === 'class') {
        this.cascadedService.reset();
        this.filterForm.patchValue({ batch: null });
        this.filterForm.get('batch')?.disable();
        this.batches = [];
      }
      return;
    }

    const numericValue = +value;

    if (type === 'department') {
      this.cascadedService.setDepartment(value);
      const matched = this.departments.find((d) => d.id === numericValue);
      this.classes = matched?.classes || [];
      this.batches = [];

      this.filterForm.patchValue({ class: null, batch: null });
      this.filterForm.get('class')?.enable();
      this.filterForm.get('batch')?.disable();
    }

    if (type === 'class') {
      this.cascadedService.setClass(value);
      const matched = this.classes.find((c) => c.id === numericValue);
      this.batches = matched?.batches || [];

      this.filterForm.patchValue({ batch: null });
      this.filterForm.get('batch')?.enable();
    }
  }

  openAnalyticsModal(calendarEvent: any, originalEvent: any) {
    const source = originalEvent ?? {};
    const rawId = this.normalizeEventId(source ?? calendarEvent?.id);
    if (!rawId) {
      this.selectedAnalyticsEvent = this.buildAnalyticsPayload(source, calendarEvent);
      this.showAllStudentRemarks = false;
      this.isAnalyticsModalOpen = true;
      return;
    }

    this.scheduleApiService.getEventById(rawId).subscribe({
      next: (res: any) => {
        const eventData = this.unwrapEventResponse(res) ?? source ?? {};
        this.selectedAnalyticsEvent = this.buildAnalyticsPayload(eventData, calendarEvent);
        this.resolveAnalyticsCourseName(eventData);
        this.showAllStudentRemarks = false;
        this.isAnalyticsModalOpen = true;
      },
      error: () => {
        this.selectedAnalyticsEvent = this.buildAnalyticsPayload(source, calendarEvent);
        this.resolveAnalyticsCourseName(source);
        this.showAllStudentRemarks = false;
        this.isAnalyticsModalOpen = true;
      },
    });
  }

  closeAnalyticsModal() {
    this.isAnalyticsModalOpen = false;
    this.selectedAnalyticsEvent = null;
    this.showAllStudentRemarks = false;
  }

  openMarkCompleteModal(card: any) {
    const source = card?.originalEvent ?? this.findOriginalEventById(card?.id) ?? {};
    const params = this.getAdditionalParameters(source?.additional_parameter);
    this.selectedMarkCompleteEvent = {
      schedule_day_id: source?.schedule_day_id,
      title: source?.summary ?? card?.title ?? 'Untitled',
      course: source?.course_title ?? source?.session_title ?? source?.summary ?? card?.title ?? 'N/A',
      date: source?.start ?? card?.start,
      time: source?.start ?? card?.start,
      teacher: this.getPrimaryTeacher(source?.attendee ?? card?.people),
      className: this.getPrimaryClass(source?.class_id),
      description: source?.description ?? 'No description available.',
      remarks: params.map((label: string) => ({
        label,
        yes: false,
        note: '',
      })),
    };
    this.isMarkCompleteModalOpen = true;
  }

  closeMarkCompleteModal() {
    this.isMarkCompleteModalOpen = false;
    this.selectedMarkCompleteEvent = null;
  }

  saveMarkComplete() {
    // Prepare the payload with remarks data
    const payload = {
      status: "end",
      remarks: this.selectedMarkCompleteEvent?.remarks?.map((remark: any) => ({
        label: remark.label,
        yes: remark.yes,
        note: remark.note
      }))
    };

    // Make API call to save remarks
    this.isReqSend = true;
    const eventId = this.selectedMarkCompleteEvent?.schedule_day_id || '';
    this.scheduleApiService.saveEventRemarks(eventId, payload).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          // Show success message
          this.toasterService.setToaster('success', 'Success', res.message ?? 'Remarks saved successfully');
          this.closeMarkCompleteModal();
          this.isReqSend = false;
        } else {
          this.toasterService.setToaster('error', 'Error', 'Failed to save remarks');
        }
      },
      error: (err: any) => {
        this.toasterService.setToaster('error', 'Error', 'Failed to save remarks');
        this.isReqSend = false;
      },
      complete: () => {
        this.isReqSend = false;
      }
    });
  }

  updateRemarkNote(index: number, event: any) {
    if (this.selectedMarkCompleteEvent?.remarks?.[index]) {
      this.selectedMarkCompleteEvent.remarks[index].note = event.target.value;
    }
  }

  updateRemarkYes(index: number, value: boolean) {
    if (this.selectedMarkCompleteEvent?.remarks?.[index]) {
      this.selectedMarkCompleteEvent.remarks[index].yes = value;
    }
  }

  private calculateEventLanes(events: any[]): any[] {
    const MAX_LANES = 4;
    const eventsWithLanes: any[] = [];

    const sortedEvents = [...events].sort(
      (a, b) =>
        new Date(a.start.replace(' ', 'T')).getTime() -
        new Date(b.start.replace(' ', 'T')).getTime(),
    );

    const laneEndTimes: number[] = [];

    for (const event of sortedEvents) {
      const eventStart = new Date(event.start.replace(' ', 'T')).getTime();
      const eventEnd = new Date(event.end.replace(' ', 'T')).getTime();

      let assignedLane = -1;

      for (let lane = 0; lane < MAX_LANES; lane++) {
        const laneEnd = laneEndTimes[lane] ?? Number.NEGATIVE_INFINITY;
        if (eventStart >= laneEnd) {
          assignedLane = lane;
          laneEndTimes[lane] = eventEnd;
          break;
        }
      }

      if (assignedLane === -1) {
        assignedLane = 0;
        laneEndTimes[assignedLane] = Math.max(laneEndTimes[assignedLane] ?? 0, eventEnd);
      }

      eventsWithLanes.push({
        event,
        column: assignedLane,
      });
    }

    return eventsWithLanes;
  }

  private normalizeParameters(value: any): string[] {
    const defaults = [""];
    if (Array.isArray(value) && value.length) {
      const clean = value
        .map((item: any) => String(item ?? '').trim())
        .filter((item: string) => !!item);
      for (const fallback of defaults) {
        // if (clean.length >= 5) break;
        if (!clean.includes(fallback)) {
          clean.push(fallback);
        }
      }
      return clean;
    }
    return defaults;
  }

  private getAdditionalParameters(value: any): string[] {
    if (Array.isArray(value) && value.length) {
      return value
        .map((item: any) => String(item ?? '').trim())
        .filter((item: string) => !!item);
    }
    return [];
  }

  private getPrimaryTeacher(attendee: any): string {
    if (Array.isArray(attendee) && attendee.length) {
      return attendee[0]?.name ?? attendee[0] ?? 'N/A';
    }
    return 'N/A';
  }

  private getPrimaryClass(classList: any): string {
    if (Array.isArray(classList) && classList.length) {
      return classList[0]?.class_name ?? classList[0]?.name ?? 'N/A';
    }
    return 'N/A';
  }

  private buildStudentRemarks(remarkLabels: string[], source: any): any[] {
    const fallbackStudents = [
      { name: 'Prajakta Bhavsar (Class : 5A)' },
      { name: 'Student Name (Class Name)' },
      { name: 'Student Name (Class Name)' },
    ];
    const students = Array.isArray(source?.students) && source.students.length
      ? source.students
      : fallbackStudents;

    return students.map((student: any, index: number) => ({
      student: student?.name ?? `Student ${index + 1}`,
      rows: remarkLabels.map((label: string, itemIndex: number) => ({
        label,
        value: itemIndex === 3 ? 'No' : 'Yes',
      })),
      note: 'Not able to complete the video session because of shortage of time.',
    }));
  }

  private buildAnalyticsPayload(source: any, calendarEvent?: any) {
    const params = this.normalizeParameters(source?.additional_parameter);
    const hasApiRemarks =
      Array.isArray(source?.remarks) && source.remarks.length > 0;
    const remarkLabels = hasApiRemarks
      ? source.remarks.map((item: any) => item?.label ?? 'Remark')
      : params;
    const teacherRemarks = hasApiRemarks
      ? source.remarks.map((item: any) => ({
          label: item?.label ?? 'Remark',
          yes: !!item?.yes,
          note: item?.note ?? '',
        }))
      : remarkLabels.map((label: string) => ({
          label,
          yes: false,
          note: '',
        }));

    return {
      title: source?.summary ?? calendarEvent?.title ?? 'Untitled',
      course:
        this.getCourseNameFromSource(source) ??
        source?.session_title ??
        source?.summary ??
        calendarEvent?.title ??
        'N/A',
      date: source?.start ?? calendarEvent?.start,
      time: source?.start ?? calendarEvent?.start,
      teacher: this.getPrimaryTeacher(source?.attendee),
      className: this.getPrimaryClass(source?.class_id),
      description: source?.description ?? 'No description available.',
      teacherRemarks,
      studentRemarks: this.buildStudentRemarks(remarkLabels, source),
    };
  }

  private resolveAnalyticsCourseName(source: any) {
    if (!this.selectedAnalyticsEvent || this.getCourseNameFromSource(source)) {
      return;
    }

    const courseId = Number(source?.course_id);
    if (!courseId) {
      return;
    }

    this.courseApiService.getCourseById(courseId).subscribe({
      next: (res: any) => {
        const course = res?.data ?? res;
        const courseName = this.getCourseNameFromSource(course);
        if (courseName && this.selectedAnalyticsEvent) {
          this.selectedAnalyticsEvent = {
            ...this.selectedAnalyticsEvent,
            course: courseName,
          };
        }
      },
      error: () => {
        // Keep the existing fallback value if course lookup fails.
      },
    });
  }

  private getCourseNameFromSource(source: any): string | null {
    const course =
      source?.course ??
      source?.course_details ??
      source?.course_detail ??
      source?.course_data;

    const name =
      source?.course_name ??
      source?.course_title ??
      course?.course_name ??
      course?.name ??
      course?.title ??
      null;

    return name ? String(name) : null;
  }

  private normalizeEventId(value: any): string | number | null {
    const raw =
      value?.schedule_day_id ??
      value?.classroom_schedule_id ??
      value?.id ??
      value?._id ??
      value?.event_id ??
      value;
    if (raw === undefined || raw === null || raw === '') return null;
    const rawString = String(raw);
    if (rawString.startsWith('evt-')) {
      return rawString.replace(/^evt-/, '').split('-')[0];
    }
    return rawString.split('-')[0];
  }

  private unwrapEventResponse(res: any) {
    return res?.status === 'success' ? res?.data : res?.data ?? res;
  }

  // Monthly analytics date range filter (frontend-only placeholder for now)
  // NOTE: Current UI already uses `stats` static values; this selection does not break anything.
  onDateRangeChange(value: string) {
    this.filterForm.patchValue({ date_range: value });

    if (value !== 'customize') {
      this.filterForm.patchValue({ customize_from: null, customize_to: null });
    }
  }

}
